import { atom } from "recoil";
import allRoutes from "routes";

export const RouteConfigState = atom({
  key: "RouteConfigManager",
  default: allRoutes,
});
